import * as React from "react";
import { TransitionGroup } from "react-transition-group";
import { Slide } from "./background-slide";

const ROTATE_EVERY = 8000;

interface IBackgroundProps {
    images: string[];
}

export const Background: React.FC<IBackgroundProps> = ({ images }) => {
    const rotateTimer = React.useRef<NodeJS.Timeout>();
    const [imageIndex, setImageIndex] = React.useState(0);

    const handleRotateImage = React.useCallback(
        // reached the end of images array - reset the index to start
        () => setImageIndex((index) => (index + 1) % images.length),
        [images],
    );

    const preloadImagesAndRotate = React.useCallback((otherImages) => {
        let loadCount = 0;

        otherImages.forEach((image) => {
            const img = new Image();
            img.onload = () => {
                loadCount = loadCount + 1;
                if (loadCount === otherImages.length) {
                    rotateTimer.current = setInterval(handleRotateImage, ROTATE_EVERY);
                }
            };
            img.src = image;
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Preload images and start rotating
    React.useEffect(() => {
        if (images.length > 1) {
            const otherImages = [];
            images.forEach((image, i) => {
                if (i !== 0) {
                    otherImages.push(image);
                }
            });
            preloadImagesAndRotate(otherImages);
        }
        return () => {
            clearInterval(rotateTimer.current);
        };
    }, [images]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <TransitionGroup
            component="div"
            style={{ height: "100%" }}
            transitionAppear={true}
            transitionAppearTimeout={450}
            transitionEnter={true}
            transitionEnterTimeout={450}
        >
            <Slide key={images[imageIndex % images.length]} image={images[imageIndex]} />
        </TransitionGroup>
    );
};

export default Background;
